import { render, staticRenderFns } from "./MyCp4.vue?vue&type=template&id=308e22db&scoped=true&"
import script from "./MyCp4.vue?vue&type=script&lang=js&"
export * from "./MyCp4.vue?vue&type=script&lang=js&"
import style0 from "./MyCp4.vue?vue&type=style&index=0&id=308e22db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308e22db",
  null
  
)

export default component.exports